import dayjs from 'dayjs';
import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';


const formatShort = (dateStr: string) =>
  new Date(dateStr.trim()).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
  });

const formatDate = (period: string) => {
  if (!period) return '';

  const formatFull = (dateStr: string) => {
    const date = new Date(dateStr.trim());
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  if (period.includes('–')) {
    // Date range
    const [start, end] = period.split('–').map(p => p.trim());
    return `${formatFull(start)} – ${formatFull(end)}`;
  }

  // Single date
  return formatShort(period);
};

const getTickFormatter = (viewMode: string, data: any[]) => {
  return (period: string) => {
    const item = data.find((d) => d.period === period);
    if (!item) return period;

    if (viewMode === 'week') {
      return `Week ${item.weekNumber ?? ''}`;
    } else if (viewMode === 'month') {
      return item.monthName ?? '';
    } else {
      return formatShort(item.period); // fallback to "20 Jun"
    }
  };
};

type CaseLineChartProps = {
  chartsData: any[]; // Adjust type as needed
  viewMode: 'week' | 'month' | 'day'; // or string if you have more
};

const CaseFinanceLineChart: React.FC<CaseLineChartProps> = ({ chartsData ,viewMode}) => (
  <ResponsiveContainer width="100%" height={400}>
    <LineChart data={chartsData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="period" tickFormatter={getTickFormatter(viewMode, chartsData)} />
      <YAxis />
      <Tooltip labelFormatter={formatDate} />
      <Legend />
      <Line type="monotone" dataKey="total_amount" stroke="#8884d8" name="Total Amount" />
    </LineChart>
  </ResponsiveContainer>
);

export default CaseFinanceLineChart;
